<template>
  <div>
    <el-form :model="pwForm" :rules="rules" ref="pwForm" label-width="15em">
      <el-form-item :label="$i18n.t('pw_old_password')" prop="oldPassword">
        <el-input v-model="pwForm.oldPassword" show-password></el-input>
      </el-form-item>
      <el-form-item :label="$i18n.t('pw_new_password')" prop="newPassword">
        <el-input v-model="pwForm.newPassword" show-password></el-input>
      </el-form-item>
      <el-form-item :label="$i18n.t('pw_retype_password')" prop="retypePassword">
        <el-input v-model="pwForm.retypePassword" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="saveInProgress" @click="submitForm()"
          >{{ $i18n.t('pw_save_password') }}
        </el-button>
        <el-button @click="resetForm()">{{ $i18n.t('pw_reset_form') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import notify from '../../utils/mixin-notify'
import { get, isArray } from 'lodash'

export default {
  name: 'ChangePassword',
  mixins: [notify],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$i18n.t('pw_empty_new_password')))
      }
      setTimeout(() => {
        if (this.pwForm.newPassword !== '') {
          this.$refs.pwForm.validateField('newPassword')
        }
        callback()
      }, this.validateTimeout)
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$i18n.t('pw_empty_retype')))
      }
      setTimeout(() => {
        if (value !== this.pwForm.newPassword) {
          callback(new Error(this.$i18n.t('pw_passwords_dont_match')))
        } else {
          callback()
        }
      }, this.validateTimeout)
    }
    return {
      formName: 'pwForm',
      validateTimeout: 300,
      saveInProgress: false,
      processId: '64942e5c74b60a001df73148',
      pwForm: {
        oldPassword: '',
        newPassword: '',
        retypePassword: '',
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: this.$i18n.t('pw_empty_old_password'),
            trigger: 'blur',
          },
        ],
        newPassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
        retypePassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  methods: {
    async submitForm() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.showNotification({
            title: 'error',
            text: 'pw_submit_error',
            type: 'error',
            duration: this.$CORE.notificationDuration,
          })
          return false
        }
      })
    },
    resetForm() {
      this.$refs[this.formName].resetFields()
    },
    async postForm() {
      this.saveInProgress = true

      const processData = await this.$client.execute({
        operationId: 'ProcessBuilder_getProcessContent',
        contentType: 'application/json',
        method: 'post',
        parameters: {
          processId: this.processId,
          modelID: this.pwForm,
        },
      })

      const success = get(processData, 'obj.data.status.success', false)

      if (success) {
        this.showNotification({
          title: 'success',
          text: 'pw_reset_success',
          type: 'success',
          duration: this.$CORE.notificationDuration,
        })
      } else {
        let errors = get(processData, 'obj.data.status.error', [])
        if (!isArray(errors)) errors = [errors]

        errors.forEach((error) => {
          this.showNotification({
            title: 'error',
            text: error,
            type: 'error',
            duration: this.$CORE.notificationDuration,
          })
        })
      }
      this.saveInProgress = false
    },
  },
}
</script>
